<template>
  <section class="section section5m">
    <div class="section-wrap-m">
      <div class="s5-top">
        <h2 class="s5-title">{{$t('home.s5_1')}}</h2>
        <p class="s5-ps" v-html="$t('home.s5_3')"></p>
      </div>
      <div class="s5-bottom">
        <img src="@/assets/images/home/map.png" v-if="$t('language.name') != 'English'">
        <img src="@/assets/images/home/map1.png" v-if="$t('language.name') == 'English'">
<!--        <p class="mobile  map-name">-->
<!--          <span v-for="(item,index) in country">{{item}}<span v-if="index != (country.length -1) ">/</span> </span>-->
<!--        </p>-->
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'homeSection5m',

    data () {
      return {
        country:this.$t('home.s5_4')
      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {

      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .English{
    .section5m{padding-bottom:.64rem;height:auto;min-height:8.88rem}
    .map-name span{display:inline-block;font-size:.22rem}

  }
  .section5m
    width: 100%;height: 8.88rem;padding-top .92rem;background-image url("~@/assets/images/home/5-bg-m.png");bgCover()
  .s5-title
    width: 100%;text-align center;font-size .4rem;color $standardColor
  .s5-ps
    margin-top .15rem;width: 100%;text-align center;font-size .26rem;color #666666
  .s5-bottom
    margin-top .7rem
  .s5-bottom img
    margin-bottom .4rem;width: 100%;
  .map-name{
    font-size .26rem;line-height .4rem;color #666666;
    span{margin:0 .2em;
      span {
        margin-right: 0
      }} 
  }
</style>
